/**
 * Created by jonas on 2023-01-11.
 */
import {BS2Symbol, BS2SymbolStates} from "./BS2Symbol";
import {BS2Reel} from "./BS2Reel";
import {gsap} from "gsap";
import {SpineGSAPWrapper} from "../animation/SpineGSAPWrapper";
import {SimpleReelModelSymbolPosition} from "../../core/reel/simplereel/SimpleReelModel";
import {XSplitData} from "../server/BS2Data";
import {BS2Statics} from "../config/BS2Statics";
import {BS2} from "../BS2";

export class XSplitSymbol extends BS2Symbol {

    constructor(_symbolName: string, initState: BS2SymbolStates, reelsView: BS2Reel, symbolsPosition?: SimpleReelModelSymbolPosition) {
        super(_symbolName, initState, reelsView, symbolsPosition);
        if (_symbolName === BS2Statics.SYMBOLS.G) {
            const spine: PIXI.spine.Spine | undefined = this.getSymbolSpine(_symbolName);
            if (spine) {
                spine.skeleton.setSkinByName("split1");
            }
        }
    }

    public getSplitAnimation(XSplitData: XSplitData | undefined): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline(),
            spine: PIXI.spine.Spine | undefined = this.getSymbolSpine(this._symbolName);
        if (spine) {
            tl.add((): void => {
                this.addSpineToView(spine);
                this.moveTosplitOverlay();
                if (this._symLandingTl && this._symLandingTl.isActive()) {
                    this._symLandingTl.kill();
                    this._symLandingTl = undefined;
                }
            })
            tl.add(SpineGSAPWrapper.createTimelineForAnimation(spine, 1, "dSplit", false));
            tl.add((): void => {
                this.moveToWinLayer();
            })
            tl.add(SpineGSAPWrapper.createTimelineForAnimation(spine, 1, "transform", false));
            tl.add((): void => {
                this.moveToNormalLayer();
            })
        }
        return tl;
    }

    public getMultiplierUpdateAnimation(value: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline(),
            spine: PIXI.spine.Spine | undefined = this.getSymbolSpine(this._symbolName);
        let finalSymSize: number | undefined = this.symbolPosition && BS2.model.data.symbolSizes[this.symbolPosition?.reelID][this.symbolPosition?.position];
        if (value === 4 && this._symbolName === BS2Statics.SYMBOLS.G) {
            if (spine) {
                tl.add(SpineGSAPWrapper.createTimelineForAnimation(spine, 0, "bladeTrans", false), 0);
            }
            if (this.symbolPosition && BS2.model.data.symbolSizes[this.symbolPosition?.reelID][this.symbolPosition?.position]) {
                tl.add(() => {
                    if (!finalSymSize) {
                        finalSymSize = 4;
                    }
                    if (spine) {
                        if (this.symbolPosition && BS2.model.data.symbolSizes[this.symbolPosition?.reelID][this.symbolPosition?.position] === 4) {
                            spine.skeleton.setSkinByName("split2");
                        } else if (this.symbolPosition && BS2.model.data.symbolSizes[this.symbolPosition?.reelID][this.symbolPosition?.position] === 8) {
                            spine.skeleton.setSkinByName("split3");
                        } else if (this.symbolPosition && BS2.model.data.symbolSizes[this.symbolPosition?.reelID][this.symbolPosition?.position] === 16 || this.symbolPosition && BS2.model.data.symbolSizes[this.symbolPosition?.reelID][this.symbolPosition?.position] === 32) {
                            spine.skeleton.setSkinByName("split4");
                        }
                    }

                }, ">")
            }
        }
        tl.add(super.getMultiplierUpdateAnimation(value, undefined), 0);
        return tl
    }
}